var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartGrey = function SvgHeartGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121619",
    d: "M16.688 3c-1.936 0-3.631.833-4.688 2.24C10.943 3.832 9.248 3 7.313 3A5.82 5.82 0 0 0 1.5 8.813c0 6.562 9.73 11.874 10.145 12.093a.75.75 0 0 0 .71 0c.415-.22 10.145-5.531 10.145-12.093A5.82 5.82 0 0 0 16.688 3M12 19.388c-1.712-.998-9-5.542-9-10.576A4.32 4.32 0 0 1 7.313 4.5c1.823 0 3.354.971 3.993 2.531a.75.75 0 0 0 1.388 0c.64-1.563 2.17-2.531 3.993-2.531A4.32 4.32 0 0 1 21 8.813c0 5.025-7.29 9.576-9 10.574"
  })));
};
export default SvgHeartGrey;